module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "document-wrapper"
  }, [_c('div', {
    staticClass: "document-container"
  }, [_c('div', {
    staticClass: "columns"
  }, [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": function($event) {
        return _vm.deleteRequiredInformation(_vm.information.id)
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-data"
  }, [_c('b-input', {
    attrs: {
      "placeholder": "Заголовок информации"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.information.title),
      callback: function($$v) {
        _vm.$set(_vm.information, "title", $$v)
      },
      expression: "information.title"
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "Текст информации",
      "type": "textarea"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.information.text),
      callback: function($$v) {
        _vm.$set(_vm.information, "text", $$v)
      },
      expression: "information.text"
    }
  }), _vm._v(" "), (_vm.showDatesTable) ? _c('table', {
    staticClass: "dates"
  }, [_vm._m(0), _vm._v(" "), _c('tbody', [_c('td', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.disclosureDate),
      callback: function($$v) {
        _vm.disclosureDate = $$v
      },
      expression: "disclosureDate"
    }
  })], 1), _vm._v(" "), _c('td', [_c('el-date-picker', {
    attrs: {
      "type": "date",
      "editable": false
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.startDate),
      callback: function($$v) {
        _vm.startDate = $$v
      },
      expression: "startDate"
    }
  }), _vm._v("\n              —\n              "), _c('el-date-picker', {
    attrs: {
      "editable": false,
      "type": "date"
    },
    on: {
      "change": _vm.dateChanged
    },
    model: {
      value: (_vm.endDate),
      callback: function($$v) {
        _vm.endDate = $$v
      },
      expression: "endDate"
    }
  })], 1)])]) : _vm._e(), _vm._v(" "), (_vm.category === 'none') ? _c('div', {
    staticClass: "button-group"
  }, [_c('a', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        return _vm.handleAddRequiredInformationDocument(_vm.information.id)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/document.svg"
    }
  }), _vm._v(" Добавить документ")]), _vm._v(" "), _c('a', {
    staticClass: "button is-info",
    on: {
      "click": _vm.addUrl
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/link.svg"
    }
  }), _vm._v("Добавить ссылку")]), _vm._v(" "), _c('a', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        return _vm.handleAddRequiredInformationRow(_vm.information.id)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/table.svg"
    }
  }), _vm._v("Добавить отчет о тех. сбоях")]), _vm._v(" "), _c('a', {
    staticClass: "button is-info",
    on: {
      "click": function($event) {
        return _vm.handleAddRequiredBookKeeping(_vm.information.id)
      }
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/icons/table.svg"
    }
  }), _vm._v("Добавить бух. отчет")])]) : _vm._e(), _vm._v(" "), (_vm.category === 'files') ? _c('div', {
    staticClass: "documents"
  }, [_vm._l((_vm.information.requiredInformationFiles), function(file) {
    return _c('BankRequirementFile', {
      key: file.id,
      attrs: {
        "file": file
      }
    })
  }), _vm._v(" "), _c('span', {
    staticClass: "button-wrapper add-new-document",
    on: {
      "click": function($event) {
        return _vm.handleAddRequiredInformationDocument(_vm.information.id)
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Прикрепить документ\n          ")])], 2) : _vm._e(), _vm._v(" "), (_vm.category === 'url') ? _c('div', {
    staticClass: "information-url"
  }, [_c('b-field', [_c('img', {
    staticClass: "delete-icon",
    attrs: {
      "src": "/static/img/icons/delete.svg"
    },
    on: {
      "click": _vm.hideUrl
    }
  }), _vm._v(" "), _c('b-input', {
    attrs: {
      "placeholder": "ссылка на сторонний ресурс или внутренний раздел сайта"
    },
    on: {
      "change": _vm.handleUpdate
    },
    model: {
      value: (_vm.information.url),
      callback: function($$v) {
        _vm.$set(_vm.information, "url", $$v)
      },
      expression: "information.url"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.category === 'rows') ? _c('div', {
    staticClass: "rows"
  }, [_c('table', [_vm._m(1), _vm._v(" "), _vm._l((_vm.information.requiredInformationRows), function(row) {
    return _c('BankRequirementRow', {
      key: row.id,
      attrs: {
        "row": row
      }
    })
  })], 2), _vm._v(" "), _c('span', {
    staticClass: "button-wrapper add-new-document",
    on: {
      "click": function($event) {
        return _vm.handleAddRequiredInformationRow(_vm.information.id)
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить строку в таблице\n          ")])]) : _vm._e(), _vm._v(" "), (_vm.category === 'bookkeeping') ? _c('div', {
    staticClass: "rows"
  }, [_c('table', {
    staticClass: "bookkeeping"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.information.requiredInformationBookkeepings), function(row) {
    return _c('BankRequirementBookkeeping', {
      key: row.id,
      attrs: {
        "row": row
      }
    })
  }), 1)]), _vm._v(" "), _c('span', {
    staticClass: "button-wrapper add-new-document",
    on: {
      "click": function($event) {
        return _vm.handleAddRequiredBookKeeping(_vm.information.id)
      }
    }
  }, [_c('a', {
    staticClass: "button is-info"
  }, [_vm._v("+")]), _vm._v(" Добавить строку в таблице\n          ")])]) : _vm._e()], 1)]), _vm._v(" "), _c('div', {
    staticClass: "centered"
  }, [_c('button', {
    staticClass: "button save-content",
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": function($event) {
        return _vm.handleSaveRequiredInformation()
      }
    }
  }, [_vm._v(_vm._s(_vm.disabled ? 'Идет сохранение...' : 'СОХРАНИТЬ'))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('td', [_vm._v("Дата раскрытия")]), _vm._v(" "), _c('td', [_vm._v("Период актуальности")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Дата и время технического сбоя")]), _vm._v(" "), _c('td', [_vm._v("Причина технического сбоя")]), _vm._v(" "), _c('td', [_vm._v("Дата раскрытия информации о техническом сбое")]), _vm._v(" "), _c('td', [_vm._v("Информация о возобновлении работоспособности")]), _vm._v(" "), _c('td', [_vm._v("Дата раскрытия информации о возобновлении")]), _vm._v(" "), _c('td')])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('tr', [_c('td', [_vm._v("Файл")]), _vm._v(" "), _c('td', [_vm._v("Дата раскрытия")]), _vm._v(" "), _c('td', [_vm._v("Период актуальности")]), _vm._v(" "), _c('td')])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d38fcc5"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Information/BankRequirementItem.vue
// module id = 952
// module chunks = 0